<template>
<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
        <v-btn large depressed rounded class="rounded-card white--text" color="analogoA" v-bind="attrs" v-on="on">
            <v-icon>note_alt</v-icon>
            Anamnese
        </v-btn>
    </template>
    <v-card color="grey lighten-3">
        <v-toolbar dark color="analogoA">
            <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Anamnese</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn color="orange" :disabled="isAnamnese" dark depressed @click="cadastrarAnamnese()">
                    Salvar
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-form v-model="form" ref="form">
            <v-alert
                v-show="(!cadastroSucesso && !isAnamnese)"
                dense
                type="warning"
                class="pa-2 ma-2"
                color="#FA9B6B"
                prominent
                border="left">
                Atenção! Os dados deste formulário só podem ser preenchidos uma única vez. Certifique-se de que todas as informações estão corretas antes de enviá-las. Não será possível alterar ou atualizar os dados após o envio. Por favor, verifique todas as informações antes de prosseguir.
            </v-alert>
            <v-alert
                v-show="isAnamnese"
                dense
                type="info"
                class="pa-2 ma-2"
                color="#79B9FA"
                prominent
                border="left">
                Atenção!
                Os dados apresentados são apenas para leitura. Não é permitida a alteração ou exclusão de qualquer informação. Se você precisar fazer alterações, entre em contato com a equipe responsável.
                Agradecemos a compreensão.
            </v-alert>
            <v-alert
                v-if="cadastroSucesso"
                dense
                type="success"
                class="pa-2 ma-2"
                prominent
                color="#32cd32"
                border="left">
                Anamnese cadastrada com sucesso!
            </v-alert>

            <v-row class="mx-1">
                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <v-textarea required :rules="[v => !!v || 'Campo obrigatório!']" v-model="anamnese.motivoConsulta" label="Qual o motivo da consulta?"></v-textarea>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>
                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                          <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                              <strong>Faz uso de cigarros?</strong>
                              <v-radio-group v-model="anamnese.cigarro">
                                    <v-radio label="Sim" value="OCASIONALMENTE"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                    <!-- <v-radio label="Frequententemente" value="FREQUENTEMENTE"></v-radio> -->
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>
                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                          <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                              <strong>Faz uso de bebida alcoólica?</strong>
                              <v-radio-group v-model="anamnese.bebidas">
                                    <v-radio label="Não" value="NAO"></v-radio>
                                    <v-radio label="Socialmente" value="SOCIALMENTE"></v-radio>
                                    <v-radio label="Moderado" value="MODERADO"></v-radio>
                                    <v-radio label="Frequentemente" value="FREQUENTEMENTE"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>
                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Tem diabetes?</strong>
                                <v-radio-group v-model="anamnese.diabetes" >
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <!-- <v-radio-group class="pl-3 mt-0 mb-0" :disabled="(anamnese.diabetes == 'NAO' || anamnese.diabetes == '')" v-model="anamnese.diabetes" label="Faz acompanhamento?">
                                        <v-radio label="Sim" value="SIMACOMPANHAMENTO"></v-radio>
                                        <v-radio label="Não" value="NAOACOMPANHAMENTO"></v-radio>
                                    </v-radio-group> -->
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>
                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>É hipertenso ou hipotenso?</strong>
                                <v-radio-group v-model="anamnese.hipertensoHipotenso">
                                    <v-radio label="Sim" value="HIPERTENSAO"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                    <!-- <v-radio label="Hipotensão" value="HIPOTENSAO"></v-radio> -->
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Existe suspeita de gravidez?</strong>
                                <v-radio-group v-model="anamnese.gravidez">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>

                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Tem alguma doença infecto-contagiosa?</strong>
                                <v-radio-group v-model="anamnese.infectoContagiosa">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <!-- <v-text-field :disabled="anamnese.infectoContagiosa != 'SIM'" label="Qual?" v-model="anamnese.descInfectoContagiosa"></v-text-field> -->
                                    <v-radio label="Não" value="NAO"></v-radio>

                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Possuí algum histórico de doença na família?</strong>
                                <v-radio-group v-model="anamnese.doencaFamiliar">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <!-- <v-text-field width="30px" class="mt-0 mb-0 ml-1" :disabled="anamnese.doencaFamiliar != 'SIM'" label="Qual?" v-model="anamnese.descDoencaFamiliar"></v-text-field> -->
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>
<!--
                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <v-radio-group v-model="anamnese.cancerFamilia" label="Tem ou ja teve algum histórico de cancer na família?">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-text-field width="30px" class="mt-0 mb-0 ml-1" :disabled="anamnese.cancerFamilia != 'SIM'" label="Qual?" v-model="anamnese.descCancerFamiliar"></v-text-field>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col> -->

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong> Faz uso de alguma medicação?</strong>
                                <v-radio-group v-model="anamnese.usoDeMedicacao">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-autocomplete :disabled="anamnese.usoDeMedicacao != 'SIM'" chips deletable-chips v-model="anamnese.medicamentos" :items="entries" :loading="isLoading" :search-input.sync="search" light multiple hide-no-data hide-selected item-text="nome" item-value="idMedicamento" label="Nome do medicamento" placeholder="Buscar" prepend-icon="mdi-databas`e-search">

                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                                <v-list-item-title v-text="item.nome"></v-list-item-title>
                                                <v-list-item-subtitle v-text="item.tarja"></v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                        <!-- <v-list-item-avatar>
                                                    <img :src="data.item.avatar">
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                    <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                -->

                                    </v-autocomplete>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <!-- <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <v-radio-group v-model="anamnese.cirurgia" label="Já fez alguma cirurgia?">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-text-field width="30px" class="mt-0 mb-0 ml-1" :disabled="anamnese.cirurgia != 'SIM'" label="Qual?" v-model="anamnese.descCirurgia"></v-text-field>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col> -->

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Já teve covid?</strong>
                                <v-radio-group v-model="anamnese.covid">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Fez exames laboratoriais nos últimos 3 meses?</strong>
                                <v-radio-group v-model="anamnese.examesLaboratoriais">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Fez alguma Usg de abdomen total recetemente?</strong>
                                <v-radio-group v-model="anamnese.abdomenTotal">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Fez algum exame cardiológico recentemente?</strong>
                                <v-radio-group v-model="anamnese.cardiologico">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Fez exames ginecológicos recentemente?</strong>
                                <v-radio-group v-model="anamnese.genecologico">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Fez mamografia recentemente?</strong>
                                <v-radio-group v-model="anamnese.mamografia">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <!-- <v-text-field width="30px" class="mt-0 mb-0 ml-1" :disabled="anamnese.mamografia != 'SIM'" label="Quanto tempo?" v-model="anamnese.descMamografia"></v-text-field> -->
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <strong>Fez exames urológicos recentemente?</strong>
                                <v-radio-group v-model="anamnese.urologico">
                                    <v-radio label="Sim" value="SIM"></v-radio>
                                    <v-radio label="Não" value="NAO"></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <v-text-field v-model="anamnese.pax" label="PA X mmHg"></v-text-field>
                                <v-text-field v-model="anamnese.frequenciaCardiaca" label="Frequência cardíaca"></v-text-field>
                                <!-- <v-text-field v-model="anamnese.temperatura" label="Temperatura"></v-text-field> -->
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>

                <v-col cols="6" sm="4" md="3" lg="3" xl="2" >
                    <v-hover v-slot="{ hover }" close-delay="200">
                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto" height="250" max-width="300">
                            <v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
                                <v-text-field v-model="anamnese.hgt" label="HGT m/dl"></v-text-field>
                                <v-text-field v-model="anamnese.sop2" label="Spo2"></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</v-dialog>
</template>

<script>
import medicoService from '../../services/medico.service'
export default {
  props: {
    ficha: Object
  },
  data () {
    return {
      form: '',
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      isAnamnese: 'false',
      anamnese: {
        id: '',
        idConsulta: '',
        idAtendimento: '',
        motivoConsulta: '',
        cigarro: null,
        bebidas: null,
        diabetes: null,
        hipertensoHipotenso: null,
        infectoContagiosa: null,
        descInfectoContagiosa: null,
        gravidez: null,
        doencaFamiliar: null,
        descDoencaFamiliar: null,
        cancerFamilia: null,
        descCancerFamiliar: null,
        usoDeMedicacao: null,
        medicamentos: [],
        cirurgia: null,
        descCirurgia: null,
        covid: null,
        examesLaboratoriais: null,
        abdomenTotal: null,
        cardiologico: null,
        genecologico: null,
        mamografia: null,
        descMamografia: null,
        urologico: null,
        pax: null,
        frequenciaCardiaca: null,
        temperatura: null,
        hgt: null,
        sop2: null
      },
      entries: [],
      search: null,
      isLoading: false,
      model: '',
      load: false,
      cadastroSucesso: false
    }
  },
  methods: {
    buscarAnamnese (idAtendimento) {
      medicoService.medico.buscarAnamnese(idAtendimento).then(r => {
        if (r.status == 200 && r.data) {
          this.isAnamnese = true
          this.anamnese = r.data
        }
      })
    },
    cadastrarAnamnese () {
      if (this.$refs.form.validate()) {
        this.load = true
        this.anamnese.idConsulta = this.ficha.idConsulta
        this.anamnese.idAtendimento = this.ficha.idAtendimento
        console.log('Cadastrar Anamnese', this.anamnese)
        medicoService.medico.cadastrarAnamnese(this.anamnese).then(r => {
          if (r.status === 200) {
            // deu bom
            this.cadastroSucesso = true
          }
        }).finally(() => {
          setTimeout(() => {
            this.dialog = false
            this.cadastroSucesso = false
            this.load = false
            this.isAnamnese = true
          }, 2000)
        })
      }
    },
    listarMedicamentos (nome) {
      if (nome != null && nome != '') {
        this.isLoading = false
        let medicamentos = null
        medicoService.medico.retornarMedicamentos(nome).then(r => {
          console.log(r.status)
          if (r.status === 200) {
            this.count = r.data.length
            this.entries = r.data
          }
        }).finally(() => {
          this.isLoading = false
        })
        return medicamentos
      }
    },
    items () {
      return this.entries.map(entry => {
        const Description = entry.principioAtivo.length > this.nome
          ? entry.nome.slice(0, this.descriptionLimit) + '...'
          : entry.nome

        return Object.assign({}, entry, {
          Description
        })
      })
    }
  },
  mounted () {
    this.isAnamnese = false
    this.buscarAnamnese(this.ficha.idAtendimento)
  },
  watch: {
    search (val) {
      // Items have already been loaded
      if (this.items.length > 0) return

      // Items have already been requested
      // if (this.isLoading) return

      // this.isLoading = true
      this.listarMedicamentos(val)
      // Lazily load input items
      // fetch('https://api.publicapis.org/entries')
      //   .then(res => res.json())
      //   .then(res => {
      //     const { count, entries } = res
      //     this.count = count
      //     this.entries = entries
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      //   .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style lang="sass" scoped>
.v-card.on-hover.theme--dark
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>
